module.exports = __webpack_public_path__ + "img/focus.4b461ce1.jpg";